export let api_url;
export let aqua_base_url;
export let aqua_socket_url;
export let usdt_token;
export let create_pool;
export let share_pool_dapp;
export let req_liquidity;
export let is_public_live;
export const platform_chainId = 42161;
export const rain_twitter_url = "https://x.com/Rain__Protocol";
export const arbiscan_url = "https://arbiscan.io/tx";
export const IS_DISTRIBUTING_POINT_OPEN = true;
export let ACTIVE_SESSION_TIME;
export const twitter_url = "https://twitter.com/intent/tweet?text";
export const whatsapp_url = "https://wa.me/?text";
export const facebook_url = "https://m.me/?text";
export const telegram_url = "https://t.me/share/url?url";
export const PAYMASTER_ADDRESS = "0x2E1A0D0F605176975cF9dCFC769e371e5C7787C6";
export const ALCHEMY_API_KEY = process.env.REACT_APP_ALCHEMY_API_ID;
export const PAYMASTER_POLICY_ID = process.env.REACT_APP_PAYMASTER_POLICY_ID;
export const ALCHEMY_RPC_URL = `https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}`;
export const IPFS_GATEWAY = `https://ipfs.io/ipfs`;
export let DISPUTE_INITIAL_TIMER;
export let CREATE_DISPUTE_WINDOW_TIMER;
export let IS_AQUA_SWAP_DEPOSIT_ACTIVE = false;
export let IS_AQUA_SWAP_WITHDRAW_ACTIVE = false;
export let IS_BLOGS_ACTIVE;
export let SHARE_MARKET_BASE_URL;
export let SHARE_MARKET;
export let SHARE_PROFILE_BASE_URL;
export let SHARE_PROFILE;
export let END_MARKET_UI_DELAY = 0;
export let RESPONSE_TIME_FOR_CREATOR = 0;
export const RAIN_CONTRACT_ADDRESS = "0xd491076c7316bc28fd4d35e3da9ab5286d079250";
export let RAIN_ARBI_CONTRACT_ADDRESS = "0x25118290e6A5f4139381D072181157035864099d";

export let CRASH_GAME_CONTRACT
export let LIQUIDITY_CONTRACT
export let LIQUIDITY_CLAIM_ADDRESS
export let GRAPH_QL_CRASH
export let RNG_CONTRACT
export let minBetGlobal
export let gameFeePercentage = 0.04

export let SHOW_CRASHGAME;
export let MIN_LIQUIDITY_DISPUTE_CREATION;
export let MIN_LIQUIDITY_APPEAL_CREATION;
const dev = "development";
const stage = "stage";
const system_ENV = process.env.REACT_APP_ENV;
export let USDT_SYMBOL = "USD₮0"
export const BIG_NUMBER_APPROVAL = 1000000000000000000000000000000000000n;

if (system_ENV === dev) {
    api_url = 'https://dev-api.riskmarkets.fun';
    aqua_base_url = "https://dev-aqua-backend.quecko.org"
    aqua_socket_url = "wss://dev-aqua-backend.quecko.org"
    create_pool = "0x148DA7F2039B2B00633AC2ab566f59C8a4C86313";
    share_pool_dapp = 'dev-app.rain.one'
    usdt_token = '0xCa4f77A38d8552Dd1D5E44e890173921B67725F4'
    req_liquidity = 0.01
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 1 * 60
    CREATE_DISPUTE_WINDOW_TIMER = 300 // seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    SHARE_MARKET_BASE_URL = "https://dev-preview-api.riskmarkets.fun/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://dev-preview-api.riskmarkets.fun/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    END_MARKET_UI_DELAY = 2 // TWO MINUTES
    RESPONSE_TIME_FOR_CREATOR = 120
    IS_BLOGS_ACTIVE = true
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0xc973DE9a335887e86309eC8419E0430fF8C0293c";
    LIQUIDITY_CONTRACT = "0xF36EBe0883461a3FB3AF1Fc9C9B5d77906fD101d";
    RNG_CONTRACT = "0x6AA3Eb6B6A80e86Ac29660ba5c0546eb69170055";
    GRAPH_QL_CRASH = "https://api.studio.thegraph.com/query/25822/rain-decision-development/version/latest"
    minBetGlobal = 1
    USDT_SYMBOL = "USDTm"
    MIN_LIQUIDITY_DISPUTE_CREATION = 0.01
    MIN_LIQUIDITY_APPEAL_CREATION = 0.02
}

else if (system_ENV === stage) {
    api_url = 'https://stg-api.riskmarkets.fun'
    aqua_base_url = "https://stg-api.aqua.cash"
    aqua_socket_url = "wss://stg-api.aqua.cash"
    create_pool = '0x6109c9f28FE3Ad84c51368f7Ef2d487ca020c561'
    share_pool_dapp = 'stg-app.rain.one'
    usdt_token = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9";
    req_liquidity = 0.01
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 1 * 60
    CREATE_DISPUTE_WINDOW_TIMER = 300// seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    IS_AQUA_SWAP_WITHDRAW_ACTIVE = true
    SHARE_MARKET_BASE_URL = "https://stg-preview-api.riskmarkets.fun/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://stg-preview-api.riskmarkets.fun/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    END_MARKET_UI_DELAY = 5 // FIVE MINUTES
    RESPONSE_TIME_FOR_CREATOR = 120
    IS_AQUA_SWAP_DEPOSIT_ACTIVE = true
    IS_BLOGS_ACTIVE = true
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0x5fB8b78844e10E445D01f4D002B71Fac9898B4c0";
    LIQUIDITY_CONTRACT = "0x9D8C968117bDD05eC0377841d55398fE4E1c9E94";
    RNG_CONTRACT = "0x497939fC514e86772b7a5671A4340421157C86a7";
    GRAPH_QL_CRASH = "https://api.goldsky.com/api/public/project_cmgzjdpsh00335np2fo348r6u/subgraphs/rain-decision/staging/gn"
    minBetGlobal = 0.001
    MIN_LIQUIDITY_DISPUTE_CREATION = 0.01
    MIN_LIQUIDITY_APPEAL_CREATION = 0.02
}

else {
    api_url = 'https://api.riskmarkets.fun'
    aqua_base_url = "https://prod-api.aqua.cash"
    aqua_socket_url = "wss://prod-api.aqua.cash"
    create_pool = '0xccCB3C03D9355B01883779EF15C1Be09cf3623F1'
    share_pool_dapp = 'rain.one'
    usdt_token = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9";
    req_liquidity = 10
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 120 * 60 // TWO HOURS
    CREATE_DISPUTE_WINDOW_TIMER = 7200 // seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    IS_AQUA_SWAP_DEPOSIT_ACTIVE = true
    SHARE_MARKET_BASE_URL = "https://preview-api.riskmarkets.fun/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://preview-api.riskmarkets.fun/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    END_MARKET_UI_DELAY = 168 * 60 // ONE WEEK
    RESPONSE_TIME_FOR_CREATOR = 24 * 60 * 60
    IS_BLOGS_ACTIVE = false
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0x4E25b638C778Dec7cbF42c6494ea99394aa5d96A";
    LIQUIDITY_CONTRACT = "0x3783c98C39c48750D92A7086D3EacBD231EF26b5";
    RNG_CONTRACT = "0x8E4fd92A32036201Ad38b4Ccf37EBdA72e6ad086";
    GRAPH_QL_CRASH = "https://api.goldsky.com/api/public/project_cmgzjdpsh00335np2fo348r6u/subgraphs/rain-decision/production/gn"
    minBetGlobal = 1
    MIN_LIQUIDITY_DISPUTE_CREATION = 10
    MIN_LIQUIDITY_APPEAL_CREATION = 20
}
